import { useState } from 'react';
import { motion } from 'framer-motion';
import RegistrationForm from '../components/RegistrationForm';
import './AshenedCup.css';

const AshenedCup = () => {
  const [showRegistration, setShowRegistration] = useState(false);

  const fadeIn = {
    hidden: { opacity: 0, y: 40 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.6 } }
  };

  const tournamentDetails = [
    { label: 'Game', value: 'Mobile Legends: Bang Bang' },
    { label: 'Format', value: '5v5' },
    { label: 'Teams', value: '256' },
    { label: 'Stages', value: 'Groups → Knockouts → Finals' },
    { label: 'Region', value: 'Open' },
  ];

  const groups = [
    { id: 'A', teams: 32, status: 'Active' },
    { id: 'B', teams: 32, status: 'Active' },
    { id: 'C', teams: 32, status: 'Upcoming' },
    { id: 'D', teams: 32, status: 'Upcoming' },
    { id: 'E', teams: 32, status: 'Upcoming' },
    { id: 'F', teams: 32, status: 'Upcoming' },
    { id: 'G', teams: 32, status: 'Upcoming' },
    { id: 'H', teams: 32, status: 'Upcoming' },
  ];

  return (
    <div className="ashened-cup">
      {/* Hero with Chaos vs Order Split */}
      <section className="ashened-hero">
        <div className="chaos-half">
          <motion.div 
            className="chaos-content"
            initial={{ x: -100, opacity: 0 }}
            animate={{ x: 0, opacity: 1 }}
            transition={{ duration: 0.8 }}
          >
            <h2 className="side-title">CHAOS</h2>
            <div className="chaos-flame">🔥</div>
          </motion.div>
        </div>

        <motion.div 
          className="hero-center"
          initial={{ scale: 0.8, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          transition={{ duration: 0.8, delay: 0.3 }}
        >
          <h1 className="ashened-title">ASHENED CUP</h1>
          <h2 className="ashened-subtitle">Where Chaos Clashes With Order</h2>
          <div className="divider-sword">⚔️</div>
        </motion.div>

        <div className="order-half">
          <motion.div 
            className="order-content"
            initial={{ x: 100, opacity: 0 }}
            animate={{ x: 0, opacity: 1 }}
            transition={{ duration: 0.8 }}
          >
            <h2 className="side-title">ORDER</h2>
            <div className="order-wings">✨</div>
          </motion.div>
        </div>
      </section>

      {/* Tournament Overview */}
      <section className="section tournament-overview">
        <div className="container">
          <motion.div
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
            variants={fadeIn}
          >
            <h2 className="section-title">Tournament Overview</h2>
            <p className="overview-text">
              Ashened Cup is a large-scale 5v5 Mobile Legends: Bang Bang tournament featuring 
              256 teams competing through structured group stages and elimination rounds under 
              professional rulesets. Experience the ultimate clash between strategic order and 
              chaotic aggression.
            </p>
          </motion.div>
        </div>
      </section>

      {/* Tournament Details */}
      <section className="section tournament-details">
        <div className="container">
          <h2 className="section-title text-gradient">Tournament Details</h2>
          
          <div className="details-grid">
            {tournamentDetails.map((detail, index) => (
              <motion.div
                key={index}
                className="detail-card card"
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: index * 0.1 }}
              >
                <div className="detail-label">{detail.label}</div>
                <div className="detail-value">{detail.value}</div>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* Groups Section */}
      <section className="section groups-section">
        <div className="container">
          <h2 className="section-title">Groups & Schedule</h2>
          
          <div className="groups-grid">
            {groups.map((group, index) => (
              <motion.div
                key={group.id}
                className="group-card card"
                initial={{ opacity: 0, scale: 0.9 }}
                whileInView={{ opacity: 1, scale: 1 }}
                viewport={{ once: true }}
                transition={{ delay: index * 0.05 }}
                whileHover={{ scale: 1.05 }}
              >
                <div className="group-header">
                  <h3>Group {group.id}</h3>
                  <span className={`status status-${group.status.toLowerCase()}`}>
                    {group.status}
                  </span>
                </div>
                <div className="group-info">
                  <p>{group.teams} Teams</p>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* Registration CTA */}
      <section className="section registration-cta">
        <div className="container">
          <motion.div
            className="cta-content"
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
          >
            <h2 className="cta-title">Ready to Enter the Arena?</h2>
            <p className="cta-text">
              Register your team now and claim your place in the Ashened Cup. 
              Limited slots available!
            </p>
            <button 
              className="btn btn-primary btn-large"
              onClick={() => setShowRegistration(true)}
            >
              Register Your Team
            </button>
          </motion.div>
        </div>
      </section>

      {/* Registration Modal */}
      {showRegistration && (
        <RegistrationForm onClose={() => setShowRegistration(false)} />
      )}
    </div>
  );
};

export default AshenedCup;
